import { I18n } from 'react-redux-i18n';

import { getTestAttributes } from '@common/utils/tests';

import { MODULE_NAME } from '../../../../pedigree-import';

import './menu.styles.scss';

export const MENU_ITEM_HEIGHT = 32;

export const Menu = (props) => {
  const { onClose, items, x, y, onTypeSelect, onChooseExistingField } = props;

  const handleTypeSelect = React.useCallback((e) => {
    const item = items.find((x) => x.id == e.target.dataset.id);

    if (item) {
      onTypeSelect(item);
    }

    onClose();
  }, [items, onTypeSelect]);

  const handleChooseExistingField = React.useCallback(() => {
    onChooseExistingField();
    onClose();
  }, []);

  return (
    <>
      <div className="PedigreeImportMenu__backdrop" {...getTestAttributes(MODULE_NAME, 'menu-close-trigger', 'box')}  onClick={onClose} />
      <div className="PedigreeImportMenu" style={{ top: y, left: x }}>
        {items.map((x) => (
          <div 
            role="button"
            key={x.id} 
            {...getTestAttributes(MODULE_NAME, 'file-column-type', 'option', x.id)} 
            style={{ height: MENU_ITEM_HEIGHT }}
            data-id={x.id} 
            className="PedigreeImportMenu__item" 
            onClick={handleTypeSelect}
          >
            {x.name}
          </div>
        ))}

        <div 
          key="exist-field" 
          role="button"
          {...getTestAttributes(MODULE_NAME, 'choose-existing-field', 'option')} 
          style={{ height: MENU_ITEM_HEIGHT }}
          className="PedigreeImportMenu__item" 
          onClick={handleChooseExistingField}
        >
          {I18n.t('Choose Existing Field')}
        </div>
      </div>
    </>
  );
};